import React from "react";
import TriloChatAvatar from "./TriloChatAvatar";
import TriloChatCopyButton from "./TriloChatCopyButton";
import TriloChatDraftCard from "./TriloChatDraftCard";
import TriloChatMessageContent from "./TriloChatMessageContent";
import { CHAT_MESSAGE_ROLE } from "../utils/triloChatConstants";

/**
 * TriloChatMessage
 *
 * One row in the conversation: avatar plus bubble. Assistant replies get
 * Markdown rendering, inline document panels and any draft cards; user messages
 * and error notices are shown as plain text.
 *
 * Props:
 * - message: { role, content, drafts }
 * - messageIndex: Position in the conversation, used to key draft state
 * - sessionId: Active session id
 * - draftStates / setDraftStates: Draft state from hooks/useTriloChatDrafts.js
 */
const TriloChatMessage = ({
  message,
  messageIndex,
  sessionId,
  draftStates,
  setDraftStates,
}) => {
  const hasDrafts = Boolean(message.drafts?.length);

  return (
    <div className={`trilochat__message trilochat__message--${message.role}`}>
      <TriloChatAvatar role={message.role} />
      <div
        className={`trilochat__bubble${hasDrafts ? " trilochat__bubble--has-drafts" : ""}`}>
        {message.role === CHAT_MESSAGE_ROLE.assistant ? (
          <>
            {message.content && (
              <>
                <TriloChatCopyButton content={message.content} />
                <TriloChatMessageContent
                  content={message.content}
                  sessionId={sessionId}
                />
              </>
            )}
            {message.drafts?.map((draft, draftIndex) => {
              const draftKey = `${messageIndex}-${draftIndex}`;
              return (
                <TriloChatDraftCard
                  key={draftKey}
                  draft={draft}
                  draftKey={draftKey}
                  draftStates={draftStates}
                  setDraftStates={setDraftStates}
                />
              );
            })}
          </>
        ) : (
          <span className="trilochat__bubble-text">{message.content}</span>
        )}
      </div>
    </div>
  );
};

export default TriloChatMessage;
